import { useState, useEffect } from 'react';
import { axiosApi } from '../../api/setupApi';

const useNISCounts = () => {
  const [counts, setCounts] = useState({ nis: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const { data } = await axiosApi.get('/nis/getCounts');
        setCounts(data || { nis: 0 });
      } catch (err) {
        setError(err.message || 'Failed to fetch counts');
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return { counts, loading, error };
};

export default useNISCounts;
